<div class="ap-container">
  <div class="d-flex align-items-center justify-content-between">
    <h2 class="mb-0">
      {{ countryName() }}
      -
      {{
        'countryInformation.taxRatesSummaries.titleTaxRateSummaries' | translate
      }}
    </h2>
    @if (showReadOnlyLabel()) {
      <span class="text-muted">
        {{ 'countryInformation.readOnly' | translate }}
      </span>
    }
  </div>
  <div class="mt-3">
    @if (tabs().length > 0) {
      <ap-tabset
        type="underline"
        [activeIndex]="active()"
        (activeIndexChange)="tabChange($event)">
        @for (tab of tabs(); track $index) {
          <ap-tab [label]="tab.name | capitalizeFirstLetter" />
        }
      </ap-tabset>
    }

    <router-outlet />
  </div>
</div>
